module.exports = __webpack_public_path__ + "img/logo_G7@2x.1f53db53.png";